/**
 * Helpers for the report category screen: field limits, the markers shown per
 * category in the list, and the state of each tab of the form.
 */

/** Maximum lengths, the same as the server accepts. */
export const CATEGORY_LIMITS = {
  name: 255,
  quick_action_name: 20,
  ai_meaning: 500,
  ai_guidance: 2000,
};

const tooLong = (value, limit) => (value || "").length > limit;
// The rich text editor leaves "<p></p>" behind when it is emptied.
const hasText = (html) =>
  !!(html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

/**
 * Markers for a category in the list: what it does and what is set up for it.
 * @param {Object} category
 * @returns {Array<{ label: string, icon: string }>}
 */
export function categoryChips(category) {
  const chips = [];
  if (category.visual)
    chips.push({ label: "Telt als gezien", icon: "mdi-eye" });
  if (category.repat)
    chips.push({ label: "Telt als vertrek", icon: "mdi-airplane-takeoff" });
  if (category.quick_action_name)
    chips.push({
      label: `Snelle actie: ${category.quick_action_name}`,
      icon: "mdi-lightning-bolt",
    });
  if (category.ai_meaning || category.ai_guidance)
    chips.push({ label: "AI-uitleg", icon: "mdi-creation-outline" });
  return chips;
}

/**
 * The tabs of the form with, per tab, whether it holds something (so it is worth
 * opening) and whether one of its fields is invalid (so it must be opened).
 *
 * @param {Object} form - the form data
 * @returns {Array<{ value: string, title: string, filled: boolean, invalid: boolean }>}
 */
export function categoryFormTabs(form) {
  return [
    {
      value: "general",
      title: "Algemeen",
      // Always has content; a dot would say nothing.
      filled: false,
      invalid:
        !(form.name || "").trim() || tooLong(form.name, CATEGORY_LIMITS.name),
    },
    {
      value: "quick_action",
      title: "Snelle actie",
      filled: !!form.quick_action_name || hasText(form.quick_action_template),
      invalid: tooLong(
        form.quick_action_name,
        CATEGORY_LIMITS.quick_action_name,
      ),
    },
    {
      value: "ai",
      title: "AI",
      filled: !!(form.ai_meaning || form.ai_guidance),
      invalid:
        tooLong(form.ai_meaning, CATEGORY_LIMITS.ai_meaning) ||
        tooLong(form.ai_guidance, CATEGORY_LIMITS.ai_guidance),
    },
  ];
}
